import type { ChatStreamCallbacks, ChatStreamEvent } from "../types";

export function parseSseLine(line: string, callbacks: ChatStreamCallbacks): boolean {
  const trimmed = line.trim();
  if (!trimmed || !trimmed.startsWith("data: ")) return false;

  const payload = trimmed.slice(6);
  if (payload === "[DONE]") return true;

  let event: ChatStreamEvent;
  try {
    event = JSON.parse(payload) as ChatStreamEvent;
  } catch {
    if (import.meta.env.DEV) console.warn("[Captain SSE] malformed event:", payload);
    return false;
  }

  dispatch(event, callbacks);
  return false;
}

function dispatch(event: ChatStreamEvent, cb: ChatStreamCallbacks): void {
  switch (event.type) {
  case "start":
    return cb.onStart(event.conversationId ?? "");
  case "content":
    return cb.onContent(event.content);
  case "thinking":
    return cb.onThinking(event.content);
  case "thinking_end":
    return cb.onThinkingEnd(event.durationSeconds);
  case "tool_call_start":
    return cb.onToolCallStart(event.toolName, event.toolCallId, event.toolCategory);
  case "tool_call_end":
    return cb.onToolCallEnd(event.toolName, event.toolCallId, event.toolCategory, event.toolResult);
  case "content_replace":
    return cb.onContentReplace(event.content, event.reason);
  case "done":
    return cb.onDone(event.promptTokens ?? 0, event.completionTokens ?? 0, event.groundednessWarning ?? false);
  case "error":
    return cb.onError(event.errorCode ?? "Captain.Unknown", event.errorMessage ?? "An unexpected error occurred.");
  }
}
